











import type { Product } from "@constructor/shared-entity/type";
import { defineComponent, type PropType } from "vue-demi";

export default defineComponent({
  name: "GGShrinkGrid",
  props: {
    list: {
      type: Array as PropType<Product[]>,
      required: true,
    },
    order: {
      type: String as PropType<"left" | "right">,
      default: "left",
    },
  },
  computed: {
    shrinkedList() {
      return this.list.filter((_, index) => index < 7); // больше 7 нет смысла рендерить, они будут скрыты
    },
    largeCount() {
      if (this.list.length >= 6) {
        return 1;
      } else {
        return 2;
      }
    },
  },
});
